import { useEffect, useRef, useState } from 'react'
import DevLog from '../../modules/devlog/Module'

import { layoutIsCompact } from '../../lib/layout'

import { ISurveyWidgetSessionPropsLayout } from '../../types'
import { WidgetWidth } from '../../modules/viewport/types'
import { ISessionUseWidgetWidthState, IWidgetWidthStyle } from '../types'

const COMPACT_LAYOUT_WIDGET_WIDTH = '100%'

const useSessionWidgetWidthState: ISessionUseWidgetWidthState = (viewportRef, layout) => {
  const [widgetWidth, setWidgetWidth] = useState<WidgetWidth>(viewportRef.current.widgetWidth)

  const widgetWidthRef = useRef<WidgetWidth>(widgetWidth)
  widgetWidthRef.current = widgetWidth

  const layoutRef = useRef<ISurveyWidgetSessionPropsLayout>(layout)
  layoutRef.current = layout

  const widgetWidthStyleRef = useRef<IWidgetWidthStyle>(null)
  if (null == widgetWidthStyleRef.current) {
    widgetWidthStyleRef.current = { width: layoutIsCompact(layout) ? COMPACT_LAYOUT_WIDGET_WIDTH : widgetWidth }
  } else {
    if (widgetWidthStyleRef.current.width !== widgetWidth) {
      widgetWidthStyleRef.current = { width: layoutIsCompact(layout) ? COMPACT_LAYOUT_WIDGET_WIDTH : widgetWidth }
    }
  }

  const dynamicWidgetWidthRef = useRef<boolean>(widgetWidthRef.current === viewportRef.current.widgetWidth)
  const updateWidgetWidthRef = useRef<(width: WidgetWidth) => void>(null)
  if (null == updateWidgetWidthRef.current) {
    updateWidgetWidthRef.current = width => {
      dynamicWidgetWidthRef.current = null == width
      const updatedWidgetWidth = dynamicWidgetWidthRef.current ? viewportRef.current.widgetWidth : width
      DevLog._log(
        'SW[session]:',
        'setWidgetWidth',
        updatedWidgetWidth,
        dynamicWidgetWidthRef.current ? '[dynamic]' : '[custom]',
        layoutIsCompact(layoutRef.current) ? '[compact]' : ''
      )
      setWidgetWidth(updatedWidgetWidth)
    }
  }
  useEffect(() => {
    if (dynamicWidgetWidthRef.current) {
      const updatedWidgetWidth = viewportRef.current.widgetWidth
      DevLog._log(
        'SW[session]:',
        'setWidgetWidth',
        updatedWidgetWidth,
        '[dynamic]',
        layoutIsCompact(layout) ? '[compact]' : ''
      )
      setWidgetWidth(updatedWidgetWidth)
    }
  }, [viewportRef.current.widgetWidth, viewportRef, layout])

  return { widgetWidthRef, setWidgetWidth: updateWidgetWidthRef.current, widgetWidthStyleRef } as const
}

export default useSessionWidgetWidthState
